<template>
    <div class="printContainer grey">
        <div v-if="spiel && landesverband" class="pageLandscape" style="position: relative">
            <div style="position: absolute; top: 25px; right: 30px">
                <img width="70" src="../../../../assets/oeskb.png">
            </div>
            <v-row>
                <v-col class="title py-0">
                    <span v-if="!spiel.saison.isCup">Meisterschaft</span> Spielbericht:
                    <span class="font-weight-bold ml-2">
                    {{landesverband.name.replace('LV - ', '').replace(' Kegeln', '')}}
                    / {{liga}}</span>
                    <div class="body-2"><span class="font-weight-bold">
                        Saison {{spiel.saison.id.substr(5).replace('_', '/')}},
                        <span v-if="spiel.saison.rundeText">{{spiel.saison.rundeText}}</span>
                        <span v-else-if="spiel.saison.semester==='A'">Runde {{spiel.saison.runde}}</span>
                        <span v-else>Runde {{spiel.saison.runde}} {{spiel.saison.semester}}</span></span>
                        <span class="ml-5 body-2 grey--text text--darken-1">
                        {{spiel.getDatumFormated()}}, {{spiel.infos.uhrzeit}}, {{spiel.infos.ort}} / {{spiel.infos.bahn}}
                        </span>
                    </div>
                </v-col>
            </v-row>
            <v-row class="pt-2">
                <v-col cols="6" class="pr-1 pt-0">
                    <spiel-bericht-print-team  :data-object="spiel" type="heim" :isLeer="isLeer">
                    </spiel-bericht-print-team>
                </v-col>
                <v-col cols="6" class="pl-1 pt-0">
                    <spiel-bericht-print-team  :data-object="spiel" type="gast" :isLeer="isLeer">
                    </spiel-bericht-print-team>
                </v-col>
            </v-row>
            <spiel-bericht-print-result v-if="!spiel.saison.isCup" :data-object="spiel" class="mt-2" :isLeer="isLeer"/>
            <spiel-bericht-print-result-cup v-else :data-object="spiel" class="mt-2" :isLeer="isLeer"/>
            <div style="width: 33.33%; position: relative" class="d-inline-block">
                <spiel-bericht-print-sign class="mt-2" type="left" :slim="true">
                    Kapitän/in Heim:
                    <span class="font-weight-bold">{{spiel.heim.captain}}</span>
                </spiel-bericht-print-sign>
                <div v-if="spiel.heim.protest" class="error--text protest caption font-weight-bold">
                    <v-icon color="error" small class="d-inline-block">mdi-alert</v-icon>
                    Protest eingelegt
                </div>
            </div>
            <div style="width: 33.33%" class="d-inline-block">
                <spiel-bericht-print-sign class="mt-2" type="left" :slim="true">
                    Schiedsrichter/in:
                    <span class="font-weight-bold">{{spiel.referee.name}}</span>
                </spiel-bericht-print-sign>
            </div>
            <div style="width: 33.33%; position: relative" class="d-inline-block">
                <spiel-bericht-print-sign class="mt-2" :slim="true">
                    Kapitän/in Gast:
                    <span class="font-weight-bold">{{spiel.gast.captain}}</span>
                </spiel-bericht-print-sign>
                <div v-if="spiel.gast.protest" class="error--text protest caption font-weight-bold">
                    <v-icon color="error" small class="d-inline-block">mdi-alert</v-icon>
                    Protest eingelegt
                </div>
            </div>
            <!-- navigation box -->
            <v-btn fab dark bottom right color="primary"
                   style="position: absolute; bottom: -80px; right: 15px;
                          z-index: 15; transform: rotate(90deg);"
                   @click="openPrint()">
                <v-icon >mdi-printer</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
    import { db } from '../../../../services/db'
    import {Spiel} from "../../../../services/data/spiel";
    import SpielBerichtPrintSign from "./spielBerichtPrint_Sign";
    import SpielBerichtPrintTeam from "./spielBerichtPrint_Team";
    import SpielBerichtPrintResult from "./spielBerichtPrint_Result";
    import SpielBerichtPrintResultCup from "@/views/ergebnisdienst/spielbericht/print/spielBerichtPrint_ResultCup";
    export default {
        components: {
            SpielBerichtPrintResultCup,
            SpielBerichtPrintResult,
            SpielBerichtPrintTeam, SpielBerichtPrintSign},
        name: "spiel-bericht-print-sp-b",
        data: () => ({
            spiel: null,
            landesverband: null,
        }),
        computed: {
            liga(){
                return this.spiel && this.landesverband ?
                    this.landesverband.ligen[this.spiel.getLigaId()].nameFull : '';
            },
            isLeer(){
                return this.$route.path.indexOf('PrintSpBLeer') !== -1;
            }
        },
        created(){
            this.setSpiel();
            //window.print();
        },
        methods: {
            setSpiel(){
                db.collection("spiele").doc(this.$route.query.id).get()
                    .then((doc) => {
                    if (doc.exists) {
                        console.log("Document data:", doc.data());
                        this.spiel = new Spiel();
                        this.spiel.setFromDataObject(doc.data());
                        this.setLandesverband();
                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            setLandesverband(){
                db.collection("landesverbaende").doc(this.spiel.saison.lvId).get()
                    .then((doc) => {
                        if (doc.exists) {
                            console.log("Document data:", doc.data());
                            this.landesverband = doc.data();
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch((error) => {
                    console.log("Error getting document:", error);
                });
            },
            openPrint(){
                window.print()
            }
        },
    }
</script>

<style scoped>
    @media print{
        @page {orientation: landscape; margin: 0}
    }
    .heim { width: 49.5%; margin-right: 0.5% }
    .gast { width: 49.5%; margin-left: 0.5% }
    .protest { position: absolute; top: 8px; right: 5px; font-size: 12px}
    .bemerkungen {border: solid 1px black; font-size: 11px; height: 140px}
    /*https://codepen.io/rafaelcastrocouto/pen/LFAes*/
</style>